import { yup } from '@guiker/yup-util'

export const generateDocusignLinkPayloadValidator = yup.object({
  redirectUrl: yup.string(),
})
